
export default {
  en: 'English',
  fr: 'French',
  de: 'German',
}
